module.exports = __webpack_public_path__ + "static/open-sans-v17-latin-italic-b61a9055d92ac56c15cacf4271d4f072.woff2";